const getPrintifyNavigation = (t, { isAdmin = false } = {}) => [
  { to: "/dropshipping/platforms", label: t("h_printify_nav_all", "Platforms") },
  { to: "/dropshipping/printify", label: t("h_printify_nav_printify", "Printify") },
  { to: "/dropshipping/printify/connect", label: t("h_printify_nav_connect", "Connection") },
  { to: "/dropshipping/printify/settings", label: t("h_printify_nav_settings", "Settings") },
  { to: "/dropshipping/printify/suppliers", label: t("h_printify_nav_suppliers", "Suppliers") },
  { to: "/dropshipping/printify/products", label: t("h_printify_nav_products", "Products") },
  { to: "/dropshipping/printify/imported", label: t("h_printify_nav_imported", "Imported") },
  { to: "/dropshipping/printify/orders", label: t("h_printify_nav_orders", "Orders") },
  { to: "/dropshipping/printify/errors", label: t("h_printify_nav_errors", "API Errors") },
  ...(isAdmin ? [{ to: "/dropshipping/printify/admin", label: t("h_printify_nav_admin", "Administration") }] : []),
];
module.exports = { getPrintifyNavigation };
